import { useState, useEffect } from 'react';
import { DropDownSelector } from '@lk-gtcom/ecomlab-components';
import { KonstantionAuthHttps } from '../../../fetchUrls';
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import './ModalAddEmployee.scss';
import { TextPage } from '../../TextPage/TextPage';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import useGeneralStore from '../../../store/general';
import customHeaders, { getSpace } from '../../../common/headers';
import { useResponseHandler } from '../../../common/auth';

const ModalAddEmployee = ({
  setShowModal,
  fetchGetEmployees,
  currentSpace
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();

  const [optionsRole, setOptionsRole] = useState([])
  const [selectedRole, setSelectedRole] = useState([]);

  const [loginExecutor, setLoginExecutor] = useState('');
  const [errSelect, setErrSelect] = useState(false);

  // Создать роль
  const fetchAddEmployee = () => {
    let url = `${KonstantionAuthHttps}/web/users/employees`

    const body = JSON.stringify({
      client_executor_login: loginExecutor,
      role_id: selectedRole?.value,
      space_id_list: [currentSpace?.id],
    });

    fetch(`${url}`, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        setTimeout(() => fetchGetEmployees(), 100)
        setShowModal(false)
      })
      .catch(handleRequestError);
  };

  // Получение ролей из пространства
  const fetchGetRoleSpace = () => {
    if (!currentSpace?.id) return;

    const abortController = new AbortController();
    const url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/${currentSpace?.id}`;

    fetch(url, { headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        const options_prop = json?.data?.map(el => ({label: el?.name, value: el?.id}))
        setOptionsRole(options_prop)
      })
      .catch(handleRequestError)
  };

  const onValidateForm = () => {
    fetchAddEmployee();
  };

  useEffect(() => {
    fetchGetRoleSpace()
  }, [currentSpace?.id]);

  return (
    <ModalComponent
      title='Добавление сотрудника'
      onClose={(e) => setShowModal(false)}
      style={{
        maxWidth: '500px',
        height: 'auto'
      }}
      child={
        <div className="modal-add-employee">
          <InputDinamycPlaceholder
            placeholder="Введите email"
            textErr="Неверный email"
            type="e-mail"
            autoComplete={false}
            onChange={setLoginExecutor}
            size='s'
            required
          />

          <DropDownSelector
            options_prop={optionsRole}
            state={selectedRole}
            setState={setSelectedRole}
            placeholder="Выберите роль"
            err={errSelect}
            width="100%"
            maxWidth='100%'
            size='s'
            required
          />

          <TextPage
            style={{
              color: '#5C7189',
              fontSize: '11px'
            }}
            text='На указанную почту будет отправлено письмо с уведомлением и
                ссылкой для подтверждения аккаунта сотрудника'
          />

          <ButtonBasic
            green
            text={'Пригласить сотрудника'}
            onClick={onValidateForm}
            disabled={!selectedRole?.value || !loginExecutor}
          />
        </div>
      }
    />
  );
};

export { ModalAddEmployee };
